var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allenamento-dettaglio"},_vm._l((_vm.allenamento.dettagli),function(dettaglio,index){return _c('div',{key:index,staticClass:"fase"},[_c('h3',{domProps:{"textContent":_vm._s(dettaglio.des_attivita)}}),_c('div',{staticClass:"pre",domProps:{"innerHTML":_vm._s(dettaglio.note_attivita)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }